module.exports = __webpack_public_path__ + "img/account-detail.afb29178.png";